import { render } from "./BottomListWallpaperProp.vue?vue&type=template&id=12611b72&scoped=true"
import script from "./BottomListWallpaperProp.vue?vue&type=script&lang=js"
export * from "./BottomListWallpaperProp.vue?vue&type=script&lang=js"

import "./BottomListWallpaperProp.vue?vue&type=style&index=0&id=12611b72&scoped=true&lang=less"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12611b72"]])

export default __exports__